import { render } from "./Media.vue?vue&type=template&id=5f0caaf3"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Layout/Media.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f0caaf3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f0caaf3', __exports__)) {
    api.reload('5f0caaf3', __exports__)
  }
  
  module.hot.accept("./Media.vue?vue&type=template&id=5f0caaf3", () => {
    api.rerender('5f0caaf3', render)
  })

}


export default __exports__